import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NAVIGATIONS } from './data/navigation/navigation.data';
import { NavigationInterceptor } from './interceptor/navigation/navigation.interceptor';
import { AboutUsPageComponent } from './page/landing-layout/about-us-page/about-us-page.component';
import { BrandingPageComponent } from './page/landing-layout/branding-page/branding-page.component';
import { ContactUsPageComponent } from './page/landing-layout/contact-us-page/contact-us-page.component';
import { CustomersPageComponent } from './page/landing-layout/customers-page/customers-page.component';
import { HomePageComponent } from './page/landing-layout/home-page/home-page.component';
import { LandingLayoutComponent } from './page/landing-layout/landing-layout.component';
import { CookiePolicyPageComponent } from './page/landing-layout/policy-pages/cookie-policy-page/cookie-policy-page.component';
import { TermsPageComponent } from './page/landing-layout/policy-pages/terms-page/terms-page.component';
import { ProductPageComponent } from './page/landing-layout/product-page/product-page.component';
import { MaintenancePageComponent } from './page/landing-layout/raw-content-pages/maintenance-page/maintenance-page.component';
import { NotFoundPageComponent } from './page/landing-layout/raw-content-pages/not-found-page/not-found-page.component';
import { ExternalRedirectPageComponent } from './page/splash-layout/external-redirect-page/external-redirect-page.component';
import { SplashLayoutComponent } from './page/splash-layout/splash-layout.component';
import { WarehousePageComponent } from './page/landing-layout/warehouse-page/warehouse-page.component';
import { GalleryPageComponent } from './page/landing-layout/gallery-page/gallery-page.component';
import { AlcadeEngineersPageComponent } from './page/landing-layout/alcade-engineers-page/alcade-engineers-page.component';
import { SrEngineersPageComponent } from './page/landing-layout/sr-engineers-page/sr-engineers-page.component';

const routes: Routes = [
  {
    path: '',
    component: LandingLayoutComponent,
    children: [
      {
        path: '',
        component: HomePageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.notFound.url,
        component: NotFoundPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.maintenance.url,
        component: MaintenancePageComponent,
        canActivate: [NavigationInterceptor],
      },
      // {
      //   path: NAVIGATIONS.cookiePolicy.url,
      //   component: CookiePolicyPageComponent,
      //   canActivate: [NavigationInterceptor],
      // },
      // {
      //   path: NAVIGATIONS.terms.url,
      //   component: TermsPageComponent,
      //   canActivate: [NavigationInterceptor],
      // },
      {
        path: NAVIGATIONS.about.url,
        component: AboutUsPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.gallery.url,
        component: GalleryPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.warehouse.url,
        component: WarehousePageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.alcadeEngineers.url,
        component: AlcadeEngineersPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.srEngineers.url,
        component: SrEngineersPageComponent,
        canActivate: [NavigationInterceptor],
      },
      // {
      //   path: NAVIGATIONS.branding.url,
      //   component: BrandingPageComponent,
      //   canActivate: [NavigationInterceptor],
      // },
      {
        path: NAVIGATIONS.customers.url,
        component: CustomersPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.contactUs.url,
        component: ContactUsPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.product.url + '/' + ':product',
        component: ProductPageComponent,
        canActivate: [NavigationInterceptor],
      },
    ],
  },
  {
    path: NAVIGATIONS.external.url,
    component: SplashLayoutComponent,
    children: [{ path: '', component: ExternalRedirectPageComponent }],
  },
  // otherwise, redirect to error
  { path: '**', redirectTo: NAVIGATIONS.notFound.url },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
